import { createSelector } from 'reselect';

import { FROM, SEARCH, TO } from 'constants/FilterConstants';
import { getById } from 'modules/interventions/selectors';

import type { InvoiceReducer } from './reducer';
import type { Invoice } from './types';

const getInvoiceState = (state: any): InvoiceReducer => state.invoices;

const getUI = createSelector(getInvoiceState, ({ ui }) => ui);

const getData = createSelector(getInvoiceState, ({ data }) => data);

const getModalState = createSelector(getUI, ({ modal }) => modal);

export const isInvoiceModalOpen = createSelector(getModalState, modal => modal.open);

export const getModalInterventionId = createSelector(getModalState, modal => modal.interventionId);

export const isFetching = createSelector(getModalState, modal => modal.loading);

export const isImporting = createSelector(getModalState, modal => modal.importing);

// Get filters from state
export const getFilters = createSelector(getUI, ({ filters }) => filters);

// Build invoice params from filters and intervention data
export const getInvoiceParams = createSelector([getById, getFilters], ({ dealer, dealerId, customerInfo }, filters) => {
  const { filterByCustomer, [FROM]: from, [TO]: to, [SEARCH]: text } = filters;

  return {
    dealerId: dealer?.id ?? dealerId,
    ...(filterByCustomer && {
      lastname: customerInfo?.lastName,
      firstname: customerInfo?.firstName,
      companyName: customerInfo?.companyName,
      customerNumber: customerInfo?.customerNumber
    }),
    from,
    to,
    ...(text ? { text } : {})
  };
});

export const getInvoices = createSelector(getData, ({ entities }): Invoice[] => Object.values(entities));
